import axios from 'axios';
import qs from 'qs'
import {baseUrl} from './env'
import router from '../router'

axios.defaults.timeout = 50000;
axios.defaults.baseURL = '';

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        //config.data = JSON.stringify(config.data);
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        // if(token){
        //     config.params = {'token':token}
        // }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//http response 拦截器
// axios.interceptors.response.use(
//     response => {
//         if(response.data.errCode ==2){
//             router.push({
//                 path:"/login",
//                 querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
//             })
//         }
//         return response;
//     },
//     error => {
//         return Promise.reject(error)
//     }
// )


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {

    window.loading.loadingShow = true;
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                window.loading.loadingShow = false;
                if (response.data.code == -100) {

                    //清空本地token
                    localStorage.token = "";
                    window.token = "";

                    router.push({
                        path: '/login'
                    })
                } else {
                    resolve(response.data);
                }
            })
            .catch(err => {
                window.loading.loadingShow = false;
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {

    axios.defaults.timeout = 10000;
    window.loading.loadingShow = true;
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data)).then(response => {
            window.loading.loadingShow = false;
            if (response.data.code == -100) {

                //清空本地token
                localStorage.token = "";
                window.token = "";
                router.push({
                    path: '/login'
                })
            } else {
                resolve(response.data);
            }
        }, err => {
            window.loading.loadingShow = false;
            reject(err)
        })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(baseUrl + url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(baseUrl + url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
